var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAlert)?_c('b-alert',{staticClass:"waiting-alert",class:_vm.$mq,attrs:{"show":""}},[_vm._v(" "+_vm._s(_vm.totalPatients)+" "+_vm._s(_vm.patients)),_c('br'),_vm._v(" "+_vm._s(_vm.$t('messages.message.waitingTreatment'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }